import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const subcriptionSession = createAsyncThunk(
  "subscriptionSession",
  async (data) => {
    try {
      const response = await instance.post(
        endpoints.subcriptionSession(), data);
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);

export const getPlans = createAsyncThunk("getPlans", async (role) => {
  try {
    const response = await instance.get(endpoints.getPlans(role));
    return response;
  } catch (error) {
    return {
      exception: error,
    };
  }
});

export const checkSubscriptionStatus = createAsyncThunk(
  "checkSubscriptionStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(endpoints.checkApiStatus(), data)
      return response
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: 'Something went wrong' });
    }
  }
)


export const cancelSubscription = createAsyncThunk(
  "cancelSubscription",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(endpoints.cancelSubscription(), data)
      return response
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: 'Something went wrong' });
    }
  }
)